import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CommandCenterReport } from "src/app/shared/models/CommandCenterReportConfiguration.item";
import { CheckRecord } from "src/app/shared/models/focusDataModels/CheckRecord";

@Component({
	selector: "app-table-performance-report",
	templateUrl: "./table-performance-report.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class TablePerformanceReportComponent implements OnInit {
	@Input() report: CommandCenterReport;

	startDate: Date;
	endDate: Date;
	revenueCenter: number;
	checks: CheckRecord[];

	tableStatistic: {
		table: string | number;
		averageTurn: number;
		averageGuest: number;
		averageCheck: number;
		checks: CheckRecord[];
	}[] = [];

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService, private focusdata: FocusdataService) {}

	ngOnInit(): void {}

	async checksGet() {
		let tempCheckList: CheckRecord[] = [];
		const promiseList = [];
		let checkDate = this.app.moment(this.startDate).format("MMDDYYYY");
		for (let i = 0; i < this.app.moment(this.endDate).add(1, "day").diff(this.app.moment(this.startDate), "days"); i++) {
			promiseList.push(
				this.focusdata
					.checksGet(this.venueService.venueKey, checkDate, true)
					.then((data) => (tempCheckList = tempCheckList.concat(data.map((i) => new CheckRecord(i)))))
			);
			checkDate = this.app.moment(checkDate, "MMDDYYYY").add(1, "day").format("MMDDYYYY");
		}

		await Promise.all(promiseList);
		tempCheckList.sort((a, b) => {
			if (a.CheckDate === b.CheckDate) {
				return a.ID > b.ID ? 1 : -1;
			}
			return this.app.moment(a.CheckDate, "MMDDYYYY").toDate() > this.app.moment(b.CheckDate, "MMDDYYYY").toDate() ? 1 : -1;
		});

		this.checks = tempCheckList;
		this.aggregateTableData(this.checks);
	}

	aggregateTableData(checks: CheckRecord[]) {
		this.tableStatistic = [];
		checks = checks.filter((i) => i.Table && i.TimeClosed);
		checks.forEach((check) => {
			const table = this.tableStatistic.find((i) => i.table === check.Table);
			if (!table) {
				this.tableStatistic.push({
					table: check.Table,
					averageTurn: this.app.moment(check.TimeClosed).diff(check.TimeOpened, "seconds") * 1000,
					averageGuest: +check.Guests > 0 ? +check.Total / +check.Guests : +check.Total / 1,
					averageCheck: +check.Total,
					checks: [check],
				});
			} else {
				const turn = this.app.moment(check.TimeClosed).diff(check.TimeOpened, "seconds") * 1000;
				table.averageTurn = (table.averageTurn + turn) / 2;
				table.averageCheck = (table.averageCheck + +check.Total) / 2;
				table.averageGuest = (table.averageGuest + (check.Guests > 0 ? +check.Total / +check.Guests : +check.Total / 1)) / 2;
				table.checks.push(check);
			}
		});
	}

	buildCharts() {}
}
